import { render, staticRenderFns } from "./PbElementBar.vue?vue&type=template&id=6a2298aa&"
import script from "./PbElementBar.vue?vue&type=script&lang=js&"
export * from "./PbElementBar.vue?vue&type=script&lang=js&"
import style0 from "./PbElementBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports